export default {
    posts: state => state.posts,
    postById: state => id => state.posts.find(post => post.id === id),
    postBySlug: state => slug => state.posts.find(post => post.slug === slug),

    postsByTagId: state => id => state.posts.filter(post => post.tags.includes(id)), // TODO: add pagination
    postsByCategoryId: state => id => state.posts.filter(post => post.categories.includes(id)), // TODO: add pagination

    tags: state => state.tags,
    tagById: state => id => state.tags.find(tag => tag.id === id),
    tagBySlug: state => slug => state.tags.find(tag => tag.slug === slug),

    categoryById: state => id => state.categories.find(category => category.id === id),
    categoryBySlug: state => slug => state.categories.find(category => category.slug === slug),
};



// WEBPACK FOOTER //
// ./src/taskflex/blog/store/_getters.js